import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

export const actionItemFullKey = (actionItemId) => ['actionItemFull', +actionItemId];
export const actionItemFullFn = ({ queryKey }) =>
  apiClient.get(`${APP_API_URL}get-action-item`, {
    params: { action_item_id: queryKey[1] },
  });

const actionItemFullSelect = ({ data }) => {
  return {
    actionItem: data?.actionItem,
    history: data?.history,
    costSavingSettings: data?.actionItemCostSavingSettings,
    costSavingTooltips: data?.costSavingTooltips,
  };
};

export const useActionItemFullQuery = ({ actionItemId }) => {
  return useQuery({
    queryKey: actionItemFullKey(actionItemId),
    queryFn: actionItemFullFn,
    enabled: !!actionItemId,
    useErrorBoundary: true,
    select: actionItemFullSelect,
  });
};
